// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared EmptyState — headline + one-line explainer + optional action.
   Uses existing tokens; works inside cards and as a full-page placeholder. */

.ui-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 48px 24px;
  gap: 8px;
}

.ui-empty-state__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin-bottom: 8px;
  border-radius: 50%;
  background: var(--bg-secondary);
  color: var(--text-muted);
}

.ui-empty-state__title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.ui-empty-state__subtitle {
  font-size: 14px;
  color: var(--text-secondary);
  max-width: 360px;
  margin: 0;
  line-height: 1.5;
}

.ui-empty-state__action {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  padding: 10px 20px;
  background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));
  color: #fff;
  border: none;
  border-radius: var(--radius-md);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  min-height: 44px;
  font-family: var(--iv-sans);
}

.ui-empty-state__action:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.4);
}

@media (max-width: 576px) {
  .ui-empty-state {
    padding: 32px 16px;
  }

  .ui-empty-state__action {
    width: 100%;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/EmptyState.css"],"names":[],"mappings":"AAAA;6EAC6E;;AAE7E;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mFAAmF;EACnF,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF","sourcesContent":["/* Shared EmptyState — headline + one-line explainer + optional action.\n   Uses existing tokens; works inside cards and as a full-page placeholder. */\n\n.ui-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 48px 24px;\n  gap: 8px;\n}\n\n.ui-empty-state__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 56px;\n  height: 56px;\n  margin-bottom: 8px;\n  border-radius: 50%;\n  background: var(--bg-secondary);\n  color: var(--text-muted);\n}\n\n.ui-empty-state__title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.ui-empty-state__subtitle {\n  font-size: 14px;\n  color: var(--text-secondary);\n  max-width: 360px;\n  margin: 0;\n  line-height: 1.5;\n}\n\n.ui-empty-state__action {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 16px;\n  padding: 10px 20px;\n  background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));\n  color: #fff;\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  min-height: 44px;\n  font-family: var(--iv-sans);\n}\n\n.ui-empty-state__action:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.4);\n}\n\n@media (max-width: 576px) {\n  .ui-empty-state {\n    padding: 32px 16px;\n  }\n\n  .ui-empty-state__action {\n    width: 100%;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
